package org.example.project.screens_sys

import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

object AbrechnungsverwaltungApi {
    private const val EMPTY_FIELD = "~"

    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadAbrechnung(firmenId: String = ""): All? =
        decodeAll(LumaticaApiManager.call("abrechnung/load/${apiPart(firmenId)}"))

    suspend fun saveAbrechnung(state: All, firmenId: String = ""): All? =
        decodeAll(
            LumaticaApiManager.call(
                "abrechnung/save-json/${apiPart(json.encodeToString(All.AllNames.serializer(), state))}/${apiPart(firmenId)}"
            )
        )

    private fun decodeAll(raw: String): All? =
        if (raw.isBlank() || raw == "null") null
        else runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()

    private fun apiPart(value: String): String {
        val clean = value.ifBlank { EMPTY_FIELD }
        return js("encodeURIComponent")(clean) as String
    }
}
